var _defs, _path, _circle, _path2, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatOssReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b",
    x1: 91.988,
    y1: 130.007,
    x2: 117.737,
    y2: 130.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b",
    x1: 41.924,
    y1: 79.412,
    x2: 100.463,
    y2: 79.412,
    xlinkHref: "#SVGID_0_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b",
    x1: 57.206,
    y1: 65.429,
    x2: 85.18,
    y2: 65.429,
    xlinkHref: "#SVGID_0_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.09 67.932l1.18-.72 20.58-12.53 20.58 12.53 20.58 12.54H95.22M101.558 80.21v24.743M150.696 80.21v36.912h-10.663V80.21M161 117.122h-34.89M68.73 117.122H53.44M83.72 117.122H73.65"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 104.916,
    cy: 129.309,
    r: 24.457
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M93.238 129.779l8.206 9.117 15.043-17.779"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M71.193 121.378L46.964 79.412C36.195 60.76 49.656 37.446 71.193 37.446h0c21.537 0 34.998 23.315 24.229 41.966l-24.229 41.966z",
    stroke: "url(#SVGID_1_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 71.193,
    cy: 65.429,
    r: 12.737,
    stroke: "url(#SVGID_2_b637cb9f2f5365949553c2f234a6cdeb544c958a932bd9e13686a3d77e7f774b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatOssReport);
export default __webpack_public_path__ + "static/media/vatOssReport.62a8576de389d18992ac75a54776625b.svg";
export { ForwardRef as ReactComponent };